import React from 'react';
import moment from 'moment';
import {DATE_FORMAT} from '../../constants';
export const tableColumns = [
    {
        Header: "Case Id",
        id: 'caseId',
        accessor: "caseId"
    },
    {
        Header: "Company Name",
        id: "correspondentEntityName",
        accessor: d => <div title={d.correspondentEntityName}>{d.correspondentEntityName}</div>
        // <div title={d.counterpartyName}>{d.counterpartyName}</div>
    },
    {
        Header: "Corporate Name",
        id: "corporateName",
        accessor: d => <div title={d.corporateName}>{d.corporateName}</div>
        // <div title={d.counterpartyName}>{d.counterpartyName}</div>
    },
    {
        Header: "Tasks",
        id: "tasksLength",
        accessor: d => <div>{d.approvedTasks}</div>
    },
    {
        Header: "Placed On",
        id: "placedOn",
        accessor: d => <div>{moment(d.createdDate).format(DATE_FORMAT)}</div>
    },
    {
        Header: "Completed On",
        id: "completedOn",
        accessor: d => <div>{moment(d.lastApprovedDate).format(DATE_FORMAT)}</div>,
        className: 'center'
    },
    {
        Header: "Price",
        id: "caseBill",
        accessor: d => <div>₹{d.caseBill}</div>,
        className: 'center'
    }
]
export const DEFAULT_PAGE_SIZE = 10;
export const COMPLETED = 'COMPLETED';
export const DATE_TEXT = 'date';
export const TO_DATE = 'toDate';
export const FROM_DATE = 'fromDate';
export const REQUEST_BODY = {
    pageNo: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    sorted: [],
    request: {
        correspondentEntityIds: [],
        fromDate: null,
        toDate: null
    }

}